module.exports = __webpack_public_path__ + "static/legend-identifier-label-do-0c199c2f21935a9d665d47c56b762022.png";